import React from "react"
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image"
import Link from "../link"
import Button from "../../ui/button"
import TelevisionOld from "../../ui/icons/outline/television-old"

type CourseCardProps = {
  name: string
  rating: number
  cover: IGatsbyImageData
  url: string
}

const CourseCard = ({ name, url, rating, cover }: CourseCardProps) => {
  return (
    <Link to={`${url}/`} external className="snap-center">
      <div className="w-[328px] lg:w-full flex flex-col border rounded-2xl h-full overflow-hidden hover:opacity-80 cursor-pointer">
        <div className="w-full">
          <GatsbyImage
            image={getImage(cover) || cover}
            alt={name}
            className="w-full"
          />
        </div>
        <div className="flex flex-col flex-grow p-4">
          <div className="flex-grow">
            <span className="text-jar-4 font-medium text-neutral-12 mb-2">
              {name}
            </span>
            <div className="flex items-center gap-1.5 text-neutral-11">
              <TelevisionOld className="size-5" />
              <p className="text-jar-3 font-medium">video</p>
              {rating && (
                <div className="flex items-center gap-1.5">
                  <p className="text-neutral-11">·</p>
                  <span className="text-jar-3 text-neutral-11">
                    ★ {rating.toFixed(1)}
                  </span>
                </div>
              )}
            </div>
          </div>
          <Button
            variant="soft"
            theme="neutral"
            size={3}
            className="mt-6 w-full"
          >
            Take this course
          </Button>
        </div>
      </div>
    </Link>
  )
}

export { CourseCard }
